// Copyright 2016 Sorama B.V.

import { BindingEngine, Disposable, autoinject, computedFrom, transient } from "aurelia-framework";
import { VersionInfo } from "datatypes/SoramaLocalApi";
import {
    IWorkflowModuleInstance,
    IWorkflowModuleLifetime,
} from "libraries/WorkflowFramework/Interfaces/IWorkflowModule";
import { ClientStatus, IClientService } from "services/Client/IClientService";

@autoinject
@transient()
export class ClientUpdateModule implements IWorkflowModuleLifetime {
    private installedVersion: VersionInfo;
    private remoteVersion: VersionInfo;

    private subscriptions: Disposable[];

    private warningMessage = "";
    private moduleInstance: IWorkflowModuleInstance;

    @computedFrom("clientService.status")
    private get isUpdateMandatory(): boolean {
        return this.clientService.status == ClientStatus.UnsupportedVersion;
    }

    constructor(
        private readonly clientService: IClientService,
        private readonly bindingEngine: BindingEngine
    ) {}

    public activateModule(moduleInstance: IWorkflowModuleInstance): void {
        this.moduleInstance = moduleInstance;

        this.subscriptions = [
            this.bindingEngine.propertyObserver(this.clientService, "status").subscribe(this.onStatusChanged),
        ];

        this.onStatusChanged();
    }

    public deactivateModule(): void {
        while (this.subscriptions.length > 0) this.subscriptions.pop().dispose();
    }

    private onUpdateCompleted(): void {
        this.clientService.updateStatus().then((status) => {
            if (status == ClientStatus.Available) {
                // Trigger a website refresh
                location.reload();
            } else {
                this.warningMessage =
                    "Sorama Acquisition Service is not updated yet. Please retry installing the Sorama Acquisition Service.";
            }
        });
    }

    private onUpdateCanceled(): void {
        if (
            this.clientService.status == ClientStatus.Available ||
            this.clientService.status == ClientStatus.OutdatedVersion
        ) {
            this.moduleInstance.closeModule();
        } else {
            this.warningMessage =
                "Sorama Acquisition Service is not updated yet. Please retry installing the Sorama Acquisition Service.";
        }
    }

    private onStatusChanged() {
        this.clientService
            .getRemoteVersion()
            .then((x) => (this.remoteVersion = x))
            .catch(() => {});

        this.clientService
            .getInstalledVersion()
            .then((x) => (this.installedVersion = x))
            .catch(() => {});
    }
}
